import axios from "axios";

export const getGeofenceList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_GEOFENCELIST_PENDING" });

      const response = await axios.get(
        `/api/admin/v1/Geofence`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_GEOFENCELIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_GEOFENCELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveGeofenceData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_GEOFENCE_PENDING" });
  
      const response = await axios.post(
        `/api/admin/v1/Add-Geofence`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_GEOFENCE_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_GEOFENCE_REJECTED", payload: error.response });
    }
  };
  

  export const getGeofenceListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_GEOFENCELISTBYID_PENDING" });

      const response = await axios.get(
        `/api/admin/v1/Geofence/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_GEOFENCELISTBYID_FULFILLED",
        payload: response.data?.data,
        vehicleCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_GEOFENCELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateGeofenceData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_GEOFENCE_PENDING" });

    const response = await axios.post(
      `/api/admin/v1/Update-Geofence/${id}`, // Endpoint URL with GEOFENCE ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_GEOFENCE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_GEOFENCE_REJECTED", payload: error.response });
  }
};

export const updateGeofenceStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_GEOFENCE_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await axios.post(
      `/api/admin/v1/Update-Geofence-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_GEOFENCE_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_GEOFENCE_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteGeofenceData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_GEOFENCE_PENDING" });

    const response = await axios.delete(
      `/api/admin/v1/Delete-Geofence/${id}`, // Endpoint URL with GEOFENCE ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_GEOFENCE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_GEOFENCE_REJECTED", payload: error.response });
  }
};